import { useIntl } from "react-intl";
import { Flex, GapSize } from "../flex";
import { ConfirmationDialogProps } from "./types";
import { Button, Text } from "@fluentui/react-components";
import { DialogView } from ".";
import { useConfirmationDialogStyle } from "./styles";

export const ConfirmationDialog = (props: ConfirmationDialogProps) => {
	const { text, onConfirm, onCancel, open, setOpen } = props;
	const intl = useIntl();
	const classes = useConfirmationDialogStyle();

	const confirmationDialogContent = () => (
		<>
			<Text>{text}</Text>
			<Flex
				hAlign="flex-end"
				gap={GapSize.Medium}
				className={classes.buttonsContainer}
			>
				<Button onClick={onCancel}>
					{intl.formatMessage({ id: "Common.Cancel" })}
				</Button>
				<Button type="submit" appearance="primary" onClick={onConfirm}>
					{intl.formatMessage({ id: "Common.Confirm" })}
				</Button>
			</Flex>
		</>
	);

	return (
		<DialogView
			content={confirmationDialogContent()}
			open={open}
			setOpen={setOpen}
			title={intl.formatMessage({ id: "Common.ConfirmationRequired" })}
		/>
	);
};
